import { matchesGqlErrorCode } from 'utils/errors/match-gql-error-code';

/**
 * The gateway refuses the actions that would release a parcel still waiting for its recipient release
 * code (UPS EPRA) unless the operator holds the dedicated role. The web hides those buttons through OPA,
 * but OPA is evaluated in the browser — so whenever the two disagree (a stale token, a role granted after
 * login) the refusal has to say what is missing instead of the action's generic failure message.
 */
export const resolveTwoFactorErrorKey = (
  error: unknown,
  fallbackKey: string
): string =>
  matchesGqlErrorCode(error, 'TwoFactorRoleRequired')
    ? 'Page.StorageUnit.Actions.TwoFactor.RoleRequired.Error'
    : fallbackKey;
